export const IS_LOGGED_IN = '/api/auth/is-logged-in'
export const IS_LOGGED_IN_API = '/auth/is-logged-in'

export const CREATE_EXISTING_SESSION = '/api/auth/create-existing-session'
export const CREATE_EXISTING_SESSION_API = '/auth/create-existing-session'

export const AUTH_LOGIN = '/api/auth/login'
export const AUTH_LOGIN_API = '/auth/login'

export const QLIK_AUTH = '/api/auth/qlik-auth'
export const QLIK_AUTH_API = '/auth/qlik-auth'

export const AUTH_LOGOUT = '/api/auth/logout'
export const AUTH_LOGOUT_API = '/auth/logout'

export const AUTH_QLIK = '/api/auth/auth-qlik'
export const AUTH_QLIK_API = '/auth/auth-qlik'

export const JWT_LOGIN = '/api/auth/sso/jwt'
export const JWT_LOGIN_API = '/auth/sso/jwt'

export const PL_LOGIN = '/api/auth/sso/pl/login'
export const PL_SAML_AUTHENTICATE = '/api/auth/sso/pl/authenticate'
export const PL_LOGIN_API = '/auth/sso/pl/login'
export const PL_SAML_AUTHENTICATE_API = '/auth/sso/pl/authenticate'

export const TCP_LOGIN = '/api/auth/sso/tcp/login'
export const TCP_SAML_AUTHENTICATE = '/api/auth/sso/tcp/authenticate'
export const TCP_LOGIN_API = '/auth/sso/tcp/login'
export const TCP_SAML_AUTHENTICATE_API = '/auth/sso/tcp/authenticate'

export const SESSION_ROUTES_TO_IGNORE = [
  AUTH_LOGIN_API,
  JWT_LOGIN_API,
  PL_LOGIN_API,
  PL_SAML_AUTHENTICATE_API,
  TCP_LOGIN_API,
  TCP_SAML_AUTHENTICATE_API,
  AUTH_QLIK_API,
  CREATE_EXISTING_SESSION_API
]
